import React, { useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CommonDropdown = ({
  label = "Select option",
  options = [],
  onSelect,
  labelKey, // optional: pass custom key for label
  valueKey, // optional: pass custom key for value
  disabled,
}) => {
  const { t } = useTranslation();
  // normalize label
  const getOptionLabel = (option) => {
    if (typeof option === "string") return option;
    if (labelKey && option[labelKey] !== undefined) return option[labelKey];
    // fallback: use first key of object
    return option[Object.keys(option)[0]];
  };

  // normalize value
  const getOptionValue = (option) => {
    if (typeof option === "string") return option;
    if (valueKey && option[valueKey] !== undefined) return option[valueKey];
    // fallback: use last key of object
    const keys = Object.keys(option);
    return option;
  };
  const selectedRef = useRef(null);
  return (
    <Dropdown
      onToggle={(isOpen) => {
        if (isOpen) {
          setTimeout(() => {
            selectedRef.current?.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
          }, 50);
        }
      }}>
      <Dropdown.Toggle
        className="form-select form-control"
        id="dropdown-common"
      >
        {t(label)}
      </Dropdown.Toggle>
      <Dropdown.Menu
        style={{ maxHeight: "200px", overflowY: "auto" }}
     
      >
        {options.length > 0 ? (
          options.map((option, index) => (
            <Dropdown.Item
              ref={label === getOptionLabel(option) ? selectedRef : null}
              key={index}
              onClick={() => onSelect(getOptionValue(option))}
              disabled={disabled}
              className={label === getOptionLabel(option) ? "active" : ""}
            >
              {t(getOptionLabel(option))}
            </Dropdown.Item>
          ))
        ) : (
          <Dropdown.Item disabled>{t("No results found")}</Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default CommonDropdown;
